export const knowledgeContent = {
  title: 'Base de conhecimento',
  description:
    'Cadastre informações que o Kraftchat usará para responder seus clientes com mais precisão.',
  helpText:
    'Exemplos: horários, preços, serviços, políticas, perguntas frequentes e informações da empresa.',
  safetyTitle: 'Boas práticas',
  safetyDescription:
    'Cadastre apenas informações úteis para atendimento. Evite dados sensíveis desnecessários.',
  closeSafetyLabel: 'Fechar aviso de boas práticas',
  createSummaryTitle: 'Novo conteúdo',
  createSummaryDescription:
    'Adicione uma informação objetiva para a IA e para os atendentes consultarem, ou cadastre um PDF.',
  createActionLabel: 'Adicionar conteúdo',
  createPdfActionLabel: 'Cadastrar PDF',
  addTitle: 'Adicionar conteúdo',
  editTitle: 'Editar conteúdo',
  pdfDialogTitle: 'Cadastrar PDF',
  pdfDialogDescription:
    'Envie um arquivo PDF com texto selecionável para adicionar à base de conhecimento.',
  pdfFileLabel: 'Arquivo PDF',
  pdfNoFileLabel: 'Nenhum arquivo selecionado',
  pdfChooseFileLabel: 'Escolher arquivo',
  pdfChangeFileLabel: 'Trocar arquivo',
  pdfSubmitLabel: 'Cadastrar PDF',
  pdfScannedWarning:
    'Este PDF precisa conter texto selecionável. PDFs digitalizados como imagem ainda não são suportados.',
  pdfFileRequiredError: 'Selecione um arquivo PDF.',
  pdfSourceLabel: 'PDF',
  textSourceLabel: 'Texto',
  replacePdfLabel: 'Substituir PDF',
  listTitle: 'Conteúdos cadastrados',
  listDescription:
    'Esses conteúdos ficam disponíveis para consulta na configuração da IA.',
  loadingLabel: 'Carregando base de conhecimento...',
  updatedAtLabel: 'Atualizado em',
  titleLabel: 'Título',
  titlePlaceholder: 'Ex: Horário de atendimento',
  contentLabel: 'Conteúdo',
  contentPlaceholder:
    'Descreva a informação de forma clara para a IA e para os atendentes.',
  activeLabel: 'Conteúdo ativo',
  activeDescription:
    'Conteúdos ativos poderão ser usados futuramente pelo assistente.',
  activeStatus: 'Ativo',
  inactiveStatus: 'Inativo',
  indexStatusPendingLabel: 'Pendente',
  indexStatusProcessingLabel: 'Processando',
  indexStatusIndexedLabel: 'Indexado',
  indexStatusFailedLabel: 'Falhou',
  emptyTitle: 'Nenhum conteúdo cadastrado ainda.',
  emptyDescription:
    'Adicione o primeiro conteúdo para começar a montar a base do assistente.',
  errorTitle: 'Não foi possível carregar a base de conhecimento.',
  errorRetryLabel: 'Tentar novamente',
  saveLabel: 'Salvar conteúdo',
  savingLabel: 'Salvando...',
  cancelLabel: 'Cancelar',
  editLabel: 'Editar',
  deleteLabel: 'Excluir',
  confirmDeleteLabel: 'Confirmar exclusão',
  deleteConfirmHint: 'Este conteúdo será removido da base de conhecimento.',
  titleRequiredError: 'Informe um título para o conteúdo.',
  contentRequiredError: 'Informe o conteúdo da base de conhecimento.',
  loadError: 'Não foi possível carregar a base de conhecimento.',
  createSuccess: 'Conteúdo criado com sucesso.',
  updateSuccess: 'Conteúdo atualizado com sucesso.',
  saveError: 'Não foi possível salvar o conteúdo.',
  deleteSuccess: 'Conteúdo excluído com sucesso.',
  deleteError: 'Não foi possível excluir o conteúdo.',
};

export const getDocumentExcerpt = content => {
  if (!content) {
    return '';
  }

  const normalizedContent = content.replace(/\s+/g, ' ').trim();

  if (normalizedContent.length <= 180) {
    return normalizedContent;
  }

  return `${normalizedContent.slice(0, 180)}...`;
};

export const formatFileSize = bytes => {
  if (bytes === null || bytes === undefined) {
    return '';
  }

  if (bytes < 1024) {
    return `${bytes} B`;
  }

  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }

  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const INDEX_STATUS_LABEL_KEYS = {
  pending: 'indexStatusPendingLabel',
  processing: 'indexStatusProcessingLabel',
  indexed: 'indexStatusIndexedLabel',
  failed: 'indexStatusFailedLabel',
};

export const indexStatusLabel = status =>
  knowledgeContent[INDEX_STATUS_LABEL_KEYS[status]] || status;

const INDEX_STATUS_BADGE_CLASSES = {
  pending: 'bg-n-alpha-2 text-n-slate-11',
  processing: 'bg-n-amber-3 text-n-amber-11',
  indexed: 'bg-n-teal-3 text-n-teal-11',
  failed: 'bg-n-ruby-3 text-n-ruby-11',
};

export const indexStatusBadgeClass = status =>
  INDEX_STATUS_BADGE_CLASSES[status] || INDEX_STATUS_BADGE_CLASSES.pending;

export const titleFromFilename = fileName => {
  const lastDotIndex = fileName.lastIndexOf('.');

  return lastDotIndex > 0 ? fileName.slice(0, lastDotIndex) : fileName;
};
